import { Injectable } from '@angular/core';

import { ApiModel } from './api.model';

@Injectable()
export class BlockedProductsModel {
    constructor(private apiModel: ApiModel) {}

    getUserBlockedProducts(brandId: string) {
        return this.apiModel.makeHttpRequest({
            method: 'GET',
            url: `${this.apiModel.getBrandsEndpoint()}/${brandId}/userBlockedProducts`
        });
    }
}
